export default __webpack_public_path__ + "static/media/insta-3.2647631e.jpg";